import { InjectionToken } from '@angular/core';

import { environment } from '../../../../environments/environment';

/** Базовый URL шлюза Qazpost (auth, cards, tracking, курсы, пошлины). Аналог `gatewayInstance` из старого проекта. */
export const GATEWAY_API_URL = new InjectionToken<string>('GATEWAY_API_URL', {
  providedIn: 'root',
  factory: () => environment.apiUrl,
});
